export default __webpack_public_path__ + "static/cocopeat-957e93ee2467e1b51db323dee16d7b24.jpeg";